import styled from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";

// styled-components
export const BatchProfileRow2Styled = styled.div`
    margin-top: ${convertPxToRem({ px: 12 })};
`;
